import { useEffect, useState } from "react";

const useInstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null)

    useEffect(() => {
        const handleBeforeInstallPrompt = (event) => {
            window.deferredPrompt = event;
            event.preventDefault() // Prevent automatic prompt
            setDeferredPrompt(event) // Save the event
        }

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt)

        return () => {
            window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt)
        }
    }, [])

    return { deferredPrompt, setDeferredPrompt }
};

export default useInstallPrompt